import React from 'react';
import { Modal } from '@storaensods/se-design-system';

import icons from './../../../icons.svg';

const ConfirmModal = ({ isOpen, close, t, message }) => {
  return (
    <Modal
      active={isOpen}
      centered={true}
      size="md"
      onClose={() => close(false)}
    >
      <p className="calibration__modal-text">{message}</p>
      <div className="calibration__modal-actions">
        <div
          className="calibration__modal-actions--cancel"
          onClick={() => close(false)}
        >
          <svg>
            <use xlinkHref={`${icons}#icon-close-outline`}></use>
          </svg>
          {t('common:close')}
        </div>
        <div
          className="calibration__modal-actions--confirm"
          onClick={() => close(true)}
        >
          <svg>
            <use xlinkHref={`${icons}#icon-checkmark-outline`}></use>
          </svg>
          {t('common:confirm')}
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
